import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './estilos/global.css'
// Importar el modulo ya deja el tema aplicado en <html>, antes de que React
// dibuje: hacerlo dentro de un efecto se veria como un parpadeo al arrancar.
import './estilos/tema'

const raiz = document.getElementById('raiz')

if (!raiz) {
    throw new Error('Falta el elemento #raiz en index.html.')
}

createRoot(raiz).render(
    <StrictMode>
        <App />
    </StrictMode>,
)

// El service worker solo en produccion: en desarrollo se interpone entre el
// navegador y Vite, y el recargado en caliente deja de verse sin explicacion.
//
// Si falla el registro, la aplicacion funciona igual; solo no se puede
// instalar. No es motivo para molestar al cajero.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch((fallo: unknown) => {
            console.warn('No se pudo registrar el service worker.', fallo)
        })
    })
}
